import "../css/Contatti.css"
import { useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPhone, faMobile, faEnvelope } from '@fortawesome/free-solid-svg-icons'

export default function MainContatti() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="contatti testo-servizi">
            <section className="contatti--hero">
                <img src="ufficio.png" alt="il nostro ufficio" className="contatti--img" />
            </section>
            <section className="contatti--text">
                <div>
                    <h2 className="contatti--h2">Contatti</h2>
                    <p className="contatti--info">
                        <FontAwesomeIcon icon={faLocationDot} />
                        Via L. Pasteur 9, Arezzo, 52100
                    </p>
                    <p className="contatti--info">
                        <FontAwesomeIcon icon={faPhone} />
                        tel: <a href="tel:0575381414">0575 381414</a>
                    </p>
                    <p className="contatti--info">
                        <FontAwesomeIcon icon={faMobile} />
                        cel: <a href="tel:+393356294364">+39 335 6294364</a>
                    </p>
                    <p className="contatti--info">
                        <FontAwesomeIcon icon={faEnvelope} />
                        e-mail: <a href="mailto:info@bulletticarrozzeria.it">info@bulletticarrozzeria.it</a>
                    </p>
                </div>
            </section>
        </main>
    )
}